import { render, staticRenderFns } from "./reviseInfo.vue?vue&type=template&id=baa77ed6&scoped=true"
import script from "./reviseInfo.vue?vue&type=script&lang=js"
export * from "./reviseInfo.vue?vue&type=script&lang=js"
import style0 from "./reviseInfo.vue?vue&type=style&index=0&id=baa77ed6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa77ed6",
  null
  
)

export default component.exports